import { useLocation } from 'react-router-dom';
import { graphForPath } from '../seo/jsonld';

// Phase C1B — emits ONE JSON-LD @graph per indexable route via React 19 native rendering
// (same hoisting model as <Seo>; ADR-0007 §14). Returns null on noindex / cross-canonical /
// non-public routes — graphForPath is the single authority on what is indexable.
export default function JsonLd() {
  const { pathname } = useLocation();
  const graph = graphForPath(pathname);
  if (!graph) return null;
  // Hardening: escape '<' so the serialized JSON can never break out of the <script> element.
  const json = JSON.stringify(graph).replace(/</g, '\\u003c');
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />;
}
